import BaseHydratable, { Hydratable } from '~/services/hydrater/hydratables/BaseHydratable'

/**
 * A Hydratable for Vue components
 */
export default class VueHydratable extends BaseHydratable implements Hydratable {
  mount(): this {
    this.component.mount(this.el)

    return this
  }

  unmount(): this {
    this.component.unmount(this.el)

    return this
  }
}
